import React from 'react';
import buttonStyles from './Button.module.scss';
import { isNullOrUndefined } from '../../helpers/object-helpers';

export interface IButton {
  id?: string;
  ariaLabel?: string;
  role?: string;
  name?: string;
  type?: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
  onClick?: () => void;
  disabled: boolean;
  mode?: 'primary' | 'secondary' | 'tertiary';
}

export default function Button({
  id,
  ariaLabel,
  name,
  type = 'button',
  children,
  onClick,
  disabled = false,
  mode = 'primary',
}: IButton) {
  const modeClassName =
    mode === 'primary'
      ? buttonStyles.primary
      : mode === 'secondary'
        ? buttonStyles.secondary
        : buttonStyles.tertiary;

  const clickEventHandler = () => {
    if (!isNullOrUndefined(onClick)) onClick();
  };

  return (
    <button
      aria-label={ariaLabel}
      id={id}
      className={[buttonStyles.button, modeClassName].join(' ')}
      type={type}
      disabled={disabled}
      name={name}
      onClick={clickEventHandler}
    >
      {children}
    </button>
  );
}
